var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2254_5202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6459 3.73402H17.3969C17.6061 3.72874 17.8142 3.76537 18.009 3.84177C18.2038 3.91817 18.3813 4.03279 18.5311 4.17887C18.681 4.32494 18.8 4.49953 18.8813 4.69234C18.9626 4.88515 19.0045 5.09228 19.0045 5.30152C19.0045 5.51077 18.9626 5.71789 18.8813 5.9107C18.8 6.10351 18.681 6.2781 18.5311 6.42418C18.3813 6.57025 18.2038 6.68487 18.009 6.76127C17.8142 6.83767 17.6061 6.8743 17.3969 6.86902H16.9529L15.7709 18.747C15.7242 19.3579 15.4493 19.9287 15.0009 20.3462C14.5526 20.7636 13.9635 20.997 13.3509 21H6.2709C5.65906 20.9966 5.07089 20.7632 4.62315 20.3462C4.1754 19.9292 3.90082 19.3591 3.8539 18.749L2.6779 6.87102H2.2379C1.8223 6.87102 1.42373 6.70593 1.12986 6.41206C0.835993 6.11819 0.670898 5.71961 0.670898 5.30402C0.670898 4.88843 0.835993 4.48985 1.12986 4.19598C1.42373 3.90211 1.8223 3.73702 2.2379 3.73702H5.9859",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98779 3.73694H13.6478",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68066 6.87195H16.9557",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7667 3.65698H5.8667V2.37898C5.8667 2.19785 5.90241 2.0185 5.97178 1.85118C6.04116 1.68386 6.14284 1.53186 6.27101 1.40388C6.39918 1.27589 6.55133 1.17443 6.71875 1.1053C6.88617 1.03616 7.06557 1.00072 7.2467 1.00098H12.3877C12.7532 1.00098 13.1037 1.14616 13.3621 1.40458C13.6205 1.66301 13.7657 2.01351 13.7657 2.37898L13.7667 3.65698Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2254_5202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.296,
    height: 21,
    fill: "white",
    transform: "translate(0.169922 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinWhite);
export default __webpack_public_path__ + "static/media/bin-white.86e8b6bca9c0cef07efc15058f82f1a7.svg";
export { ForwardRef as ReactComponent };